import { MutationTree } from "vuex";
import { CompanyImageState, ICompanyImage } from "@/types/company_image";

const mutations: MutationTree<CompanyImageState> = {
  list: (state, sites: ICompanyImage[]) => {
    state.list = sites;
  },
  single: (state, company_image: ICompanyImage) => {
    state.company_image = company_image;
  },
  clear: state => {
    state.list = [];
  }
};

export default mutations;
